"use client";

import { forwardRef as e, memo as t, useEffect as o, useImperativeHandle as n, useLayoutEffect as r, useMemo as i, useReducer as s, useRef as l } from "react";

import { jsx as c } from "react/jsx-runtime";

import { flushSync as f } from "react-dom";

var {min: u, max: d, abs: a, floor: h} = Math, g = (e, t, o) => u(o, d(t, e)), p = e => [ ...e ].sort((e, t) => e - t), v = "function" == typeof queueMicrotask ? queueMicrotask : e => {
    Promise.resolve().then(e);
}, m = () => {
    let e;
    return [ new Promise(t => {
        e = t;
    }), e ];
}, _ = e => {
    let t;
    return () => (e && (t = e(), e = void 0), t);
}, w = (e, t, o) => {
    const n = o ? "unshift" : "push";
    for (let o = 0; o < t; o++) e[n](-1);
    return e;
}, S = (e, t) => {
    const o = e.t[t];
    return -1 === o ? e.o : o;
}, $ = (e, t, o) => {
    const n = -1 === e.t[t];
    return e.t[t] = o, e.i = u(t, e.i), n;
}, z = (e, t) => {
    if (!e.l) return 0;
    if (e.i >= t) return e.u[t];
    e.i < 0 && (e.u[0] = 0, e.i = 0);
    let o = e.i, n = e.u[o];
    for (;o < t; ) n += S(e, o), e.u[++o] = n;
    return e.i = t, n;
}, b = (e, t, o = 0, n = e.l - 1) => {
    let r = o;
    for (;o <= n; ) {
        const i = h((o + n) / 2);
        z(e, i) <= t ? (r = i, o = i + 1) : n = i - 1;
    }
    return g(r, 0, e.l - 1);
}, y = (e, t, o) => {
    const n = t - e.l;
    return e.i = o ? -1 : u(t - 1, e.i), e.l = t, n > 0 ? (w(e.u, n), w(e.t, n, o), 
    e.o * n) : (e.u.splice(n), (o ? e.t.splice(0, -n) : e.t.splice(n)).reduce((t, o) => t - (-1 === o ? e.o : o), 0));
}, x = "undefined" != typeof window, I = e => e.documentElement, k = e => e.ownerDocument, R = e => e.defaultView, T = /*#__PURE__*/ _(() => !!/iP(hone|od|ad)/.test(navigator.userAgent) || "MacIntel" === navigator.platform && navigator.maxTouchPoints > 0), C = /*#__PURE__*/ _(() => "scrollBehavior" in I(document).style), M = e => d(e.h(), e.p()), O = (e, t = 40, o = 0, n, r = !1) => {
    let i = !!o, s = 1, l = 0, c = 0, f = 0, h = 0, g = 0, v = 0, m = 0, _ = 0, x = null, I = [ 0, i ? d(o - 1, 0) : -1 ], k = 0, R = !1;
    const C = ((e, t, o) => ({
        o: t,
        t: o ? w(o.slice(0, u(e, o.length)), d(0, e - o.length)) : w([], e),
        l: e,
        i: -1,
        u: w([], e + 1)
    }))(e, n ? n[1] : t, n && n[0]), M = /* @__PURE__ */ new Set, O = () => f - c, E = () => O() + g + h, H = (e, t) => ((e, t, o, n) => {
        if (n = u(n, e.l - 1), z(e, n) <= t) {
            const r = b(e, o, n);
            return [ b(e, t, n, r), r ];
        }
        {
            const r = b(e, t, void 0, n);
            return [ r, b(e, o, r) ];
        }
    })(C, e, t, I[0]), W = () => z(C, C.l), B = (e, t) => {
        const o = z(C, e) - g;
        return t ? W() - o - J(e) : o;
    }, J = e => S(C, e), A = (e, t = -1) => C.t[e] === t, L = e => {
        e && (T() && 0 !== m || x && 1 === _ ? g += e : h += e);
    };
    return {
        v: () => {
            M.clear();
        },
        m: () => s,
        _: () => (e => [ e.t.slice(), e.o ])(C),
        S: (e = 200) => {
            if (!R || i) return I;
            let t, o;
            if (v) [t, o] = I; else {
                let n = d(0, E()), i = n + l;
                r || (e = d(0, e), 1 !== m && (n -= e), 2 !== m && (i += e)), [t, o] = I = H(d(0, n), d(0, i)), 
                x && (t = u(t, x[0]), o = d(o, x[1]));
            }
            return [ d(t, 0), u(o, C.l - 1) ];
        },
        $: e => b(C, e - c),
        I: A,
        k: B,
        R: J,
        T: () => C.l,
        C: () => f,
        M: () => 0 !== m,
        p: () => l,
        O: () => c,
        h: W,
        H: () => (v = h, h = 0, [ v, 2 === _ ]),
        W: (e, t) => {
            const o = [ e, t ];
            return M.add(o), () => {
                M.delete(o);
            };
        },
        B: (e, t) => {
            let o, n, u = 0;
            switch (e) {
              case 1:
                {
                    if (t === f && 0 === _) break;
                    const e = v;
                    v = 0;
                    const o = t - f, r = a(o);
                    e && r < a(e) + 1 || 0 !== _ || (m = o < 0 ? 2 : 1), i && (i = !1), f = t, u = 4;
                    const s = O();
                    s >= -l && s <= W() && (u += 1, n = r > l);
                    break;
                }

              case 2:
                u = 8, 0 !== m && (o = !0, u += 1), m = 0, _ = 0, x = null;
                break;

              case 3:
                {
                    const e = t.filter(([e, t]) => !A(e, t));
                    if (!e.length) break;
                    L(e.reduce((e, [t, o]) => {
                        let n;
                        if (2 === _) n = !0; else if (x && 1 === _) n = t < x[0]; else {
                            const e = O(), o = B(t), r = J(t);
                            n = 1 !== m && 0 === _ ? o + r <= e : o < e && o + r < e + l;
                        }
                        return n && (e += o - J(t)), e;
                    }, 0));
                    for (const [t, o] of e) {
                        const e = J(t), n = $(C, t, o);
                        r && (k += n ? o : o - e);
                    }
                    r && l && k > l && (L(((e, t) => {
                        let o = 0;
                        const n = [];
                        e.t.forEach((e, r) => {
                            -1 !== e && (n.push(e), r < t && o++);
                        }), e.i = -1;
                        const r = p(n), i = r.length, s = i / 2 | 0, l = i % 2 == 0 ? (r[s - 1] + r[s]) / 2 : r[s], c = e.o;
                        return ((e.o = l) - c) * d(t - o, 0);
                    })(C, b(C, E()))), r = !1), u = 3, n = !0;
                    break;
                }

              case 4:
                l !== t && (l || (R = n = !0), l = t, u = 3);
                break;

              case 5:
                t[1] ? (L(y(C, t[0], !0)), _ = 2, u = 1) : (y(C, t[0]), u = 1);
                break;

              case 6:
                c = t;
                break;

              case 7:
                _ = 1;
                break;

              case 8:
                x = H(t, t + l), u = 1;
            }
            u && (s = 1 + (2147483647 & s), o && g && (h += g, g = 0), M.forEach(([e, t]) => {
                u & e && t(n);
            }));
        }
    };
}, E = setTimeout, H = (e, t) => t ? -e : e, W = (e, t, o, n, r, i) => {
    const s = Date.now;
    let l = 0, c = !1, f = !1, u = !1, d = !1;
    const a = (() => {
        let t;
        const o = () => {
            null != t && clearTimeout(t);
        }, n = () => {
            o(), t = E(() => {
                t = null, (() => {
                    if (c || f) return c = !1, void a();
                    u = !1, e.B(2);
                })();
            }, 150);
        };
        return n.J = o, n;
    })(), h = () => {
        l = s(), u && (d = !0), i && e.B(6, i()), e.B(1, n()), a();
    }, g = t => {
        if (c || !e.M() || t.ctrlKey) return;
        const n = s() - l;
        150 > n && 50 < n && (o ? t.deltaX : t.deltaY) && (c = !0);
    }, p = () => {
        f = !0, u = d = !1;
    }, v = () => {
        f = !1, T() && (u = !0);
    };
    return t.addEventListener("scroll", h), t.addEventListener("wheel", g, {
        passive: !0
    }), t.addEventListener("touchstart", p, {
        passive: !0
    }), t.addEventListener("touchend", v, {
        passive: !0
    }), {
        A: () => {
            t.removeEventListener("scroll", h), t.removeEventListener("wheel", g), t.removeEventListener("touchstart", p), 
            t.removeEventListener("touchend", v), a.J();
        },
        L: () => {
            const [t, o] = e.H();
            t && (r(t, o, d), d = !1, o && e.p() > e.h() && e.B(1, n()));
        }
    };
}, B = (e, t, o) => {
    let n;
    return [ async (r, i) => {
        if (!await t()) return;
        n && n();
        const s = () => {
            const [t, o] = m();
            return n = () => {
                o(!1);
            }, e.p() && E(n, 150), [ t, e.W(2, () => {
                o(!0);
            }) ];
        };
        if (i && C()) e.B(8, r()), v(async () => {
            for (;;) {
                let t = !0;
                for (let [o, n] = e.S(); o <= n; o++) if (e.I(o)) {
                    t = !1;
                    break;
                }
                if (t) break;
                const [o, n] = s();
                try {
                    if (!await o) return;
                } finally {
                    n();
                }
            }
            e.B(7), o(r(), i);
        }); else for (;;) {
            const [t, n] = s();
            try {
                if (e.B(7), o(r()), !await t) return;
            } finally {
                n();
            }
        }
    }, () => {
        n && n();
    } ];
}, J = (e, t) => {
    let o, n, r = m(), i = !1;
    const s = t ? "scrollLeft" : "scrollTop", l = t ? "overflowX" : "overflowY", [c, f] = B(e, () => r[0], (e, n) => {
        e = H(e, i), n ? o.scrollTo({
            [t ? "left" : "top"]: e,
            behavior: "smooth"
        }) : o[s] = e;
    });
    return {
        N(c, u) {
            o = u, t && (i = "rtl" === getComputedStyle(u).direction), n = W(e, u, t, () => H(u[s], i), (t, o, n) => {
                if (n) {
                    const e = u.style, t = e[l];
                    e[l] = "hidden", E(() => {
                        e[l] = t;
                    });
                }
                u[s] = H(e.C() + t, i), o && f();
            }), r[1](!0);
        },
        v() {
            n && n.A(), r[1](!1), r = m();
        },
        P: () => i,
        V(e) {
            c(() => e);
        },
        X(t) {
            t += e.C(), c(() => t);
        },
        Y(t, {align: o, smooth: n, offset: r = 0} = {}) {
            if (t = g(t, 0, e.T() - 1), "nearest" === o) {
                const n = e.k(t), r = e.C();
                if (n < r) o = "start"; else {
                    if (!(n + e.R(t) > r + e.p())) return;
                    o = "end";
                }
            }
            c(() => r + e.O() + e.k(t) + ("end" === o ? e.R(t) - e.p() : "center" === o ? (e.R(t) - e.p()) / 2 : 0), n);
        },
        q: () => {
            n && n.L();
        }
    };
}, A = (e, t) => {
    let o, n, r = m(), i = !1;
    const s = t ? "left" : "top", [l] = B(e, () => r[0], (e, t) => {
        e = H(e, i);
        const n = R(k(o));
        t ? n.scroll({
            [s]: e,
            behavior: "smooth"
        }) : n.scroll({
            [s]: e
        });
    }), c = (e, t, o, n, r = 0) => {
        const s = n ? "offsetLeft" : "offsetTop", l = r + (n && i ? o.innerWidth - e[s] - e.offsetWidth : e[s]), f = e.offsetParent;
        return e !== t && f ? c(f, t, o, n, l) : l;
    };
    return {
        N(l) {
            o = l;
            const f = t ? "scrollX" : "scrollY", u = k(l), d = R(u);
            t && (i = "rtl" === getComputedStyle(I(u)).direction), n = W(e, d, t, () => H(d[f], i), (t, o) => {
                o ? d.scroll({
                    [s]: H(e.C() + t, i)
                }) : d.scrollBy({
                    [s]: H(t, i)
                });
            }, () => c(l, u.body, d, t)), r[1](!0);
        },
        v() {
            n && n.A(), o = void 0, r[1](!1), r = m();
        },
        P: () => i,
        q: () => {
            n && n.L();
        },
        Y(n, {align: r, smooth: i, offset: s = 0} = {}) {
            if (!o) return;
            if (n = g(n, 0, e.T() - 1), "nearest" === r) {
                const t = e.k(n), o = e.C();
                if (t < o) r = "start"; else {
                    if (!(t + e.R(n) > o + e.p())) return;
                    r = "end";
                }
            }
            const f = k(o), u = R(f), d = I(f), a = () => e.p() - (t ? d.clientWidth : d.clientHeight);
            l(() => s + c(o, f.body, u, t) + e.k(n) + ("end" === r ? e.R(n) - (e.p() - a()) : "center" === r ? (e.R(n) - (e.p() - a())) / 2 : 0), i);
        }
    };
}, L = (e, t) => {
    const o = J(e, !1), n = J(t, !0);
    return {
        N(e, t) {
            o.N(e, t), n.N(e, t);
        },
        v() {
            o.v(), n.v();
        },
        P: n.P,
        V(e, t) {
            null != e && o.V(e), null != t && n.V(t);
        },
        X(e, t) {
            null != e && o.X(e), null != t && n.X(t);
        },
        Y(e, t) {
            null != e && o.Y(e), null != t && n.Y(t);
        },
        q() {
            o.q(), n.q();
        }
    };
}, N = e => {
    let t;
    return {
        j(o) {
            (t || (t = new (R(k(o)).ResizeObserver)(e))).observe(o);
        },
        D(e) {
            t.unobserve(e);
        },
        A() {
            t && t.disconnect();
        }
    };
}, P = (e, t) => {
    let o;
    const n = t ? "width" : "height", r = /* @__PURE__ */ new WeakMap, i = N(t => {
        const i = [];
        for (const {target: s, contentRect: l} of t) if (s.offsetParent) if (s === o) e.B(4, l[n]); else {
            const e = r.get(s);
            null != e && i.push([ e, l[n] ]);
        }
        i.length && e.B(3, i);
    });
    return {
        G(e) {
            i.j(o = e);
        },
        U: (e, t) => (r.set(e, t), i.j(e), () => {
            r.delete(e), i.D(e);
        }),
        v: i.A
    };
}, V = (e, t) => {
    const o = t ? "width" : "height", n = t ? "innerWidth" : "innerHeight", r = /* @__PURE__ */ new WeakMap, i = N(t => {
        const n = [];
        for (const {target: e, contentRect: i} of t) {
            if (!e.offsetParent) continue;
            const t = r.get(e);
            null != t && n.push([ t, i[o] ]);
        }
        n.length && e.B(3, n);
    });
    let s;
    return {
        G(t) {
            const o = R(k(t)), r = () => {
                e.B(4, o[n]);
            };
            o.addEventListener("resize", r), v(r), s = () => {
                o.removeEventListener("resize", r);
            };
        },
        U: (e, t) => (r.set(e, t), i.j(e), () => {
            r.delete(e), i.D(e);
        }),
        v() {
            s && s(), i.A();
        }
    };
}, X = (e, t) => {
    let o;
    const n = /* @__PURE__ */ new WeakMap, r = /* @__PURE__ */ new Set, i = /* @__PURE__ */ new Set, s = /* @__PURE__ */ new Map, l = (e, t) => `${e}-${t}`, c = N(c => {
        const f = /* @__PURE__ */ new Set, u = /* @__PURE__ */ new Set;
        for (const {target: r, contentRect: {width: i, height: d}} of c) if (r.offsetParent) if (r === o) e.B(4, d), 
        t.B(4, i); else {
            const e = n.get(r);
            if (e) {
                const [t, o] = e, n = l(t, o), r = s.get(n);
                let c, a;
                r ? (r[0] !== d && (c = !0), r[1] !== i && (a = !0)) : c = a = !0, c && f.add(t), 
                a && u.add(o), (c || a) && s.set(n, [ d, i ]);
            }
        }
        if (f.size) {
            const t = [];
            f.forEach(e => {
                let o = 0;
                i.forEach(t => {
                    const n = s.get(l(e, t));
                    n && (o = d(o, n[0]));
                }), o && t.push([ e, o ]);
            }), e.B(3, t);
        }
        if (u.size) {
            const e = [];
            u.forEach(t => {
                let o = 0;
                r.forEach(e => {
                    const n = s.get(l(e, t));
                    n && (o = d(o, n[1]));
                }), o && e.push([ t, o ]);
            }), t.B(3, e);
        }
    });
    return {
        G(e) {
            c.j(o = e);
        },
        U: (e, t, o) => (n.set(e, [ t, o ]), r.add(t), i.add(o), c.j(e), () => {
            n.delete(e), c.D(e);
        }),
        F(o) {
            for (const [t] of o) for (let o = 0; o < e.T(); o++) s.delete(l(o, t));
            t.B(3, o);
        },
        K(o) {
            for (const [e] of o) for (let o = 0; o < t.T(); o++) s.delete(l(e, o));
            e.B(3, o);
        },
        v: c.A
    };
}, Y = x ? r : o, q = "current", j = (e, t) => {
    if (Array.isArray(e)) for (const o of e) j(o, t); else null == e || "boolean" == typeof e || t.push(e);
}, D = (e, t) => {
    const o = e.key;
    return null != o ? o : "_" + t;
}, G = e => {
    const t = l(null);
    return t.current || (t.current = e());
}, U = e => {
    const t = l(e);
    return Y(() => {
        t[q] = e;
    }, [ e ]), t;
}, F = /*#__PURE__*/ t(({Z: e, ee: t, te: o, oe: n, ne: r, re: s, ie: f, se: u}) => {
    const d = l(null);
    Y(() => t(d[q], o), [ o ]);
    const a = i(() => {
        const e = {
            contain: "layout style",
            position: r && u ? void 0 : "absolute",
            [f ? "height" : "width"]: "100%",
            [f ? "top" : "left"]: 0,
            [f ? "left" : "top"]: n,
            visibility: !r || u ? void 0 : "hidden"
        };
        return f && (e.display = "inline-flex"), e;
    }, [ n, r, u, f ]);
    /* @__PURE__ */
    return c(s, "string" == typeof s ? {
        ref: d,
        style: a,
        children: e
    } : {
        ref: d,
        style: a,
        index: o,
        children: e
    });
}), K = (e, t) => i(() => {
    if ("function" == typeof e) return [ o => e(t[o], o), t.length ];
    const o = (e => {
        const t = [];
        return j(e, t), t;
    })(e);
    return [ e => o[e], o.length ];
}, [ e, t ]), Q = /*#__PURE__*/ e(({children: e, data: t, bufferSize: o, itemSize: r, shift: i, horizontal: u, keepMounted: d, cache: a, startMargin: h = 0, ssrCount: g, as: m = "div", item: _ = "div", scrollRef: w, onScroll: S, onScrollEnd: $}, z) => {
    const [b, y] = K(e, t), x = l(null), I = l(!!g), k = U(S), R = U($), [T, C, E, H] = G(() => {
        const e = !!u, t = O(y, r, g, a, !r);
        return [ t, P(t, e), J(t, e), e ];
    });
    y !== T.T() && T.B(5, [ y, i ]), h !== T.O() && T.B(6, h);
    const [W, B] = s(T.m, void 0, T.m), A = T.M(), L = T.h(), N = E.P(), V = [], X = e => {
        const t = b(e);
        /* @__PURE__ */
        return c(F, {
            ee: C.U,
            te: e,
            oe: T.k(e, N),
            ne: T.I(e),
            re: _,
            Z: t,
            ie: H,
            se: I[q]
        }, D(t, e));
    };
    if (Y(() => {
        I[q] = !1, T.W(1, e => {
            e ? f(B) : B();
        }), T.W(4, () => {
            k.current && k.current(T.C());
        }), T.W(8, () => {
            R.current && R.current();
        });
        const e = x[q], t = t => {
            C.G(t), E.N(e, t);
        };
        return w ? v(() => {
            w.current && t(w[q]);
        }) : t(e.parentElement), () => {
            T.v(), C.v(), E.v();
        };
    }, []), Y(() => {
        E.q();
    }, [ W ]), n(z, () => ({
        get cache() {
            return T._();
        },
        get scrollOffset() {
            return T.C();
        },
        get scrollSize() {
            return M(T);
        },
        get viewportSize() {
            return T.p();
        },
        findItemIndex: T.$,
        getItemOffset: T.k,
        getItemSize: T.R,
        scrollToIndex: E.Y,
        scrollTo: E.V,
        scrollBy: E.X
    }), []), d) {
        const e = new Set(d);
        for (let [t, n] = T.S(o); t <= n; t++) e.add(t);
        p([ ...e ]).forEach(e => {
            V.push(X(e));
        });
    } else for (let [e, t] = T.S(o); e <= t; e++) V.push(X(e));
    /* @__PURE__ */
    return c(m, {
        ref: x,
        style: {
            contain: "size style",
            overflowAnchor: "none",
            flex: "none",
            position: "relative",
            width: H ? L : "100%",
            height: H ? "100%" : L,
            pointerEvents: A ? "none" : void 0
        },
        children: V
    });
}), Z = /*#__PURE__*/ e(({children: e, data: t, bufferSize: o, itemSize: n, shift: r, horizontal: i, keepMounted: s, cache: l, ssrCount: f, item: u, onScroll: d, onScrollEnd: a, style: h, ...g}, p) => /* @__PURE__ */ c("div", {
    ...g,
    style: {
        display: i ? "inline-block" : "block",
        [i ? "overflowX" : "overflowY"]: "auto",
        contain: "strict",
        width: "100%",
        height: "100%",
        ...h
    },
    children: /* @__PURE__ */ c(Q, {
        ref: p,
        data: t,
        bufferSize: o,
        itemSize: n,
        shift: r,
        horizontal: i,
        keepMounted: s,
        cache: l,
        ssrCount: f,
        item: u,
        onScroll: d,
        onScrollEnd: a,
        children: e
    })
})), ee = /*#__PURE__*/ e(({children: e, data: t, bufferSize: o, itemSize: r, shift: i, horizontal: u, cache: d, ssrCount: a, as: h = "div", item: g = "div", onScroll: p, onScrollEnd: v}, m) => {
    const [_, w] = K(e, t), S = l(null), $ = U(p), z = U(v), b = l(!!a), [y, x, I, k] = G(() => {
        const e = !!u, t = O(w, r, a, d, !r);
        return [ t, V(t, e), A(t, e), e ];
    });
    w !== y.T() && y.B(5, [ w, i ]);
    const [R, T] = s(y.m, void 0, y.m), C = y.M(), M = y.h(), E = I.P(), H = [];
    Y(() => {
        b[q] = !1, y.W(1, e => {
            e ? f(T) : T();
        }), y.W(4, () => {
            $.current && $.current();
        }), y.W(8, () => {
            z.current && z.current();
        });
        const e = S[q];
        return x.G(e), I.N(e), () => {
            y.v(), x.v(), I.v();
        };
    }, []), Y(() => {
        I.q();
    }, [ R ]), n(m, () => ({
        get cache() {
            return y._();
        },
        get scrollOffset() {
            return y.C();
        },
        get viewportSize() {
            return y.p();
        },
        findItemIndex: y.$,
        getItemOffset: y.k,
        getItemSize: y.R,
        scrollToIndex: I.Y
    }), []);
    for (let [e, t] = y.S(o); e <= t; e++) {
        const t = _(e);
        H.push(/* @__PURE__ */ c(F, {
            ee: x.U,
            te: e,
            oe: y.k(e, E),
            ne: y.I(e),
            re: g,
            Z: t,
            ie: k,
            se: b[q]
        }, D(t, e)));
    }
    /* @__PURE__ */
    return c(h, {
        ref: S,
        style: {
            contain: "size style",
            overflowAnchor: "none",
            flex: "none",
            position: "relative",
            width: k ? M : "100%",
            height: k ? "100%" : M,
            pointerEvents: C ? "none" : void 0
        },
        children: H
    });
}), te = (e, t) => `${e}-${t}`, oe = /*#__PURE__*/ t(({Z: e, ee: t, le: o, ce: n, fe: r, ue: s, de: f, ae: u, ne: d, he: a}) => {
    const h = l(null);
    return Y(() => t.U(h[q], o, n), [ n, o ]), /* @__PURE__ */ c(a, {
        ref: h,
        style: i(() => ({
            contain: "layout style",
            display: "grid",
            position: "absolute",
            top: r,
            left: s,
            visibility: d ? "hidden" : void 0,
            minHeight: f,
            minWidth: u
        }), [ r, s, u, f, d ]),
        children: e
    });
}), ne = /*#__PURE__*/ e(({children: e, row: t, col: o, cellHeight: r = 40, cellWidth: u = 100, bufferSize: d, ssrRowCount: a, ssrColCount: h, item: g = "div", domRef: p, onScroll: v, onScrollEnd: m, style: _, ...w}, S) => {
    const [$, z, b, y] = G(() => {
        const e = O(t, r, a), n = O(o, u, h);
        return [ e, n, X(e, n), L(e, n) ];
    });
    t !== $.T() && $.B(5, [ t ]), o !== z.T() && z.B(5, [ o ]);
    const [x, I] = s($.m, void 0, $.m), [k, R] = s(z.m, void 0, z.m), T = $.M(), C = z.M(), E = M($), H = M(z), W = l(null), B = U(v), J = U(m);
    Y(() => {
        $.W(1, e => {
            e ? f(I) : I();
        }), z.W(1, e => {
            e ? f(R) : R();
        }), $.W(4, () => {
            B.current && B.current($.C());
        }), $.W(8, () => {
            J.current && J.current();
        });
        const e = W[q], t = e.parentElement;
        return b.G(t), y.N(e, t), () => {
            $.v(), z.v(), b.v(), y.v();
        };
    }, []), Y(() => {
        y.q();
    }, [ x, k ]), n(S, () => ({
        get scrollTop() {
            return $.C();
        },
        get scrollLeft() {
            return z.C();
        },
        get scrollHeight() {
            return M($);
        },
        get scrollWidth() {
            return M(z);
        },
        get viewportHeight() {
            return $.p();
        },
        get viewportWidth() {
            return z.p();
        },
        findRowIndex: $.$,
        findColIndex: z.$,
        getRowOffset: $.k,
        getColOffset: z.k,
        getRowSize: $.R,
        getColSize: z.R,
        resizeCols(e) {
            b.F(e);
        },
        resizeRows(e) {
            b.K(e);
        },
        scrollToIndex: y.Y,
        scrollTo: y.V,
        scrollBy: y.X
    }), []);
    const A = i(() => {
        const t = /* @__PURE__ */ new Map;
        return (o, n) => {
            let r = t.get(te(o, n));
            return r || t.set(te(o, n), r = e({
                rowIndex: o,
                colIndex: n
            })), r;
        };
    }, [ e ]), N = y.P(), [P, V] = $.S(d), [j, D] = z.S(d), F = [];
    for (let e = P; e <= V; e++) for (let t = j; t <= D; t++) F.push(/* @__PURE__ */ c(oe, {
        ee: b,
        le: e,
        ce: t,
        fe: $.k(e),
        ue: z.k(t, N),
        de: $.R(e),
        ae: z.R(t),
        ne: $.I(e) || z.I(t),
        he: g,
        Z: A(e, t)
    }, te(e, t)));
    /* @__PURE__ */
    return c("div", {
        ref: p,
        ...w,
        style: {
            overflow: "auto",
            contain: "strict",
            width: "100%",
            height: "100%",
            ..._
        },
        children: /* @__PURE__ */ c("div", {
            ref: W,
            style: {
                contain: "size style",
                overflowAnchor: "none",
                flex: "none",
                position: "relative",
                width: H,
                height: E,
                pointerEvents: T || C ? "none" : void 0
            },
            children: F
        })
    });
});

export { Z as VList, Q as Virtualizer, ee as WindowVirtualizer, ne as experimental_VGrid };
//# sourceMappingURL=index.js.map